import { createReducer } from '@ngrx/store';

export interface UiState {}

export const initialUiState: UiState = {};

export const uiReducer = createReducer(initialUiState);
